import {
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE,
  ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION,
  ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION,
} from "../i18n/keysTranslations";

export const ONBOARDING_CHECKLIST_ACTION_KEYS = {
  BRAND_SETUP: "brandSetup",
  CREATIVES: "creatives",
  PUBLISH: "publish",
  CAMPAIGN: "campaign",
};

export const ONBOARDING_CHECKLIST_STEPS = [
  {
    id: 1,
    flagKey: "brandSetup",
    titleKey: ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE,
    descriptionKey: ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION,
    actionKey: ONBOARDING_CHECKLIST_ACTION_KEYS.BRAND_SETUP,
  },
  {
    id: 2,
    flagKey: "creatives",
    titleKey: ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE,
    descriptionKey: ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION,
    actionKey: ONBOARDING_CHECKLIST_ACTION_KEYS.CREATIVES,
  },
  {
    id: 3,
    flagKey: "posts",
    titleKey: ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE,
    descriptionKey: ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION,
    actionKey: ONBOARDING_CHECKLIST_ACTION_KEYS.PUBLISH,
  },
  {
    id: 4,
    flagKey: "campaigns",
    titleKey: ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE,
    descriptionKey: ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION,
    actionKey: ONBOARDING_CHECKLIST_ACTION_KEYS.CAMPAIGN,
  },
];
